import type { OwnerGroupPart, OwnerPart } from 'src/contracts/querySelections';

export const getOwnerValue = (item: {
  owners: OwnerPart[];
  ownerGroups: OwnerGroupPart[];
}) =>
  item.owners.length || item.ownerGroups.length
    ? item.owners
        .map((o) => o.user?.FriendlyName)
        .concat(item.ownerGroups.map((o) => o.group?.Name))
        .join(', ')
    : '-';
